import { render, staticRenderFns } from "./problemTypeSheet.vue?vue&type=template&id=f56849c4&scoped=true&lang=pug"
import script from "./problemTypeSheet.vue?vue&type=script&lang=js"
export * from "./problemTypeSheet.vue?vue&type=script&lang=js"
import style0 from "./problemTypeSheet.vue?vue&type=style&index=0&id=f56849c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56849c4",
  null
  
)

export default component.exports